import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { IFormRiskLevelsControlProps } from './FormRiskLevelsControl.interface';

import './style.scss';

const riskLevelIds = [1, 2, 3];

const FormRiskLevelsControl: FC<IFormRiskLevelsControlProps> = ({ className, value, onEdit }) => {
  const { t } = useTranslation();

  const riskLevels = useMemo(
    () =>
      riskLevelIds.map(riskLevelId => ({
        riskLevelId,
        value: value.find(item => item.riskLevelId === riskLevelId),
      })),
    [value],
  );

  return (
    <div className={cn('form-risk-levels-control', className)}>
      {riskLevels.map(({ riskLevelId, value }) => (
        <div className="form-risk-levels-control__item" key={riskLevelId}>
          <div className="form-risk-levels-control__label" onClick={() => onEdit(riskLevelId)}>
            {value
              ? t('admin.editRiskLevelDescription', { level: riskLevelId })
              : t('admin.setRiskLevelDescription', { level: riskLevelId })}
            *
          </div>
          {value && (
            <div className="form-risk-levels-control__description">
              {value.riskLevelDescription}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FormRiskLevelsControl;
